import { useEffect, useState } from 'react';
import { useAppDispatch } from '@/data/store/utils/redux';
import { getAvailablePlanLedgersAsync } from '@/data/store/actions';

/**
 * Whether the organization's plan carries the NAERAS add-on.
 *
 * `null` while the answer is still on its way, so a screen can hold its layout
 * instead of flashing the "not available" state at everyone who loads it. Every
 * `/naeras/*` route is gated on this perk server-side too — this only decides
 * what the UI offers.
 */
export function useNaerasPerk(): boolean | null {
  const dispatch = useAppDispatch();
  const [hasNaerasPerk, setHasNaerasPerk] = useState<boolean | null>(null);

  useEffect(() => {
    const attemptGetAvailablePlanLedgers = async () => {
      try {
        const ledger = await dispatch(getAvailablePlanLedgersAsync({})).unwrap();
        setHasNaerasPerk(ledger?.perks?.naeras === true);
      } catch {
        setHasNaerasPerk(false);
      }
    };

    attemptGetAvailablePlanLedgers();
  }, [dispatch]);

  return hasNaerasPerk;
}

export default useNaerasPerk;
